import { CreditCardFormValues } from './CreditCardForm';
import { FormikErrors } from 'formik';
import { validateFormikCreditCardValues } from '@tock/shared/forms/credit-card/CreditCardValidation';

export const ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD';

// TODO: take out form specific logic to make generic
export function validateCreditCardFormValues(
  { cvc, expiry, name, number, zipCode, selectedCardId }: CreditCardFormValues,
  revalidateSavedCreditCards: boolean
): FormikErrors<CreditCardFormValues> {
  const errors: FormikErrors<CreditCardFormValues> = {};

  // Saved and revalidating
  if (
    selectedCardId !== ADD_PAYMENT_METHOD &&
    revalidateSavedCreditCards &&
    window.braintreeHostedField
  ) {
    const hostedFieldState = window.braintreeHostedField.getState();
    if (!hostedFieldState.fields.cvv.isValid) {
      errors.cvc = 'Your security code is invalid.';
    }
    return errors;
  }

  // Saved card, no revalidation required <= $100
  if (selectedCardId !== ADD_PAYMENT_METHOD && !revalidateSavedCreditCards) {
    return errors;
  }

  return {
    ...errors,
    ...validateFormikCreditCardValues({
      cvc,
      expiry,
      name,
      number,
      zipCode,
      skipAvsCheck: false,
      saveNewCard: false,
    }),
  };
}
